// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { BunzlActionUnion } from "@store/Framework/Store/Bunzl/BunzlReducer";
import { Draft } from "immer";

export const isSignatureModel = (signature: any): signature is SignatureModel => {
    return signature && signature.timestamp && signature.customerName && signature.customerSignature;
};
export interface SignatureData {
    timestamp: string;
    customerEmail?: string;
    customerName: string;
    customerSignature: string;
}
export interface SignatureModel extends SignatureData {
    orderNumber?: string;
}

export type SignatureState = ApplicationState["bunzl"]["pages"]["Signature"];
export const initialSignatureState = {
    Signature: undefined,
};

export const signatureStateActions = {
    "Store/Pages/Signature": (draft: Draft<SignatureState>, action: { action: SignatureData | undefined }) => {
        draft.Signature = action.action;
    },
} as const;

const signatureReducer = createTypedReducerWithImmer(initialSignatureState, signatureStateActions);
export type SignatureActions = BunzlActionUnion<typeof signatureStateActions>;

export default signatureReducer;
